<template>
    <div id='order-status'>
        <b-container fluid>
           
           <b-row>
               <b-col lg='4' md='6' sm='12'>
                    <b-form id='order-form' class="" @submit.prevent='sendOrderAction'>
                        <label for="action-type-select" class="mb-0 mt-3">Укажите статус:</label>
                        <b-form-select
                            id="action-type-select"
                            class=""
                            size='sm'
                            :options="actionTypes"
                            v-model='_selectedType'
                            @change='selectType'
                        ></b-form-select>

                        
                        <b-form-group class='mt-3'>
                            <label for='doer-input' class='mb-0' v-html="doerLabel"></label>
                            <b-form-input 
                                id='doer-inpit'
                                v-model="_doer" 
                                class=" doer-input" 
                                size='sm'  
                                @input='updateDoer' 
                                type='text' 
                                placeholder="ФИО..."></b-form-input>
                            <b-form-invalid-feedback :state="validDoer" class='text-center'>
                                <em>Укажите ФИО</em>
                            </b-form-invalid-feedback>
                        </b-form-group>

                        

                        <b-form-group v-if='_selectedType === 1'>
                            <label for='email-input' class='mb-0'>Email:</label>
                            <b-form-input 
                                v-model="_email" 
                                class=" doer-input" 
                                size='sm'
                                @input='updateEmail' 
                                type="email" 
                                placeholder="Email..."
                                id="email-input" 
                                name="email" 
                                autocomplete="email"
                            ></b-form-input>
                            <b-form-invalid-feedback :state="validEmail" class='text-center'>
                                <em>Укажите Email</em>
                            </b-form-invalid-feedback>
                        </b-form-group>


                        <b-button type="submit" name="submit" class="float-right mb-3" size='sm' variant="outline-dark" :disabled="!validDoer">Отправить</b-button>
                    </b-form>
               </b-col>
           </b-row>
            

            <b-table id='routes-table' striped hover :items="routes" :fields='routesFields'>
                <template v-slot:cell(email)="row">
                    <p v-if='row.item.email === "null"'></p>
                    <p v-else>{{ row.item.email }}</p>
                </template>
            </b-table>

            <b-list-group
                class='short-list'
                v-for='(route, index) in routes'
                :key='index'
            >
                <b-list-group-item>
                    <p class='py-0 my-0'>Действие: <b>{{ route.type_action }}</b></p>
                    <p class='py-0 my-0'>Дата: {{ route.d }} | Время: {{ route.t }}</p>
                    <p class='py-0 my-0'>Исполнитель: {{ route.doer }}</p>
                    <p class='py-0 my-0 route-mail'>Email: {{ route.email }}</p>
                </b-list-group-item>
            </b-list-group>

        </b-container>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
    name: 'order-status',
    data() {
        return {
            routesFields: [
                { key: 'type_action', label: 'Действие'},
                { key: 'doer', label: 'Исполнитель'},
                { key: 'email', label: 'Email'},
                { key: 'd', label: 'Дата'},
                { key: 't', label: 'Время'}
            ],
            actionTypes: [
                { text: 'Передан', value: 1 },
                { text: 'Выполнен', value: 2 },
                { text: 'Отказ заказчика', value: 3 },
                { text: 'Отказ исполнителя', value: 4 },
            ],
            doerLabel: 'ФИО адресата'
        }
    },
    methods: {
        ...mapActions('structs', ['getCovidStruct']),
        ...mapActions('order', ['selectType', 'updateDoer', 'updateEmail', 'sendOrderAction'])
    },
    computed: {
        ...mapState({
            struct: state => state.structs.struct,
            routes: state => state.order.routes,
            selectedType: state => state.order.orderOptions.selectedType,
            doer: state => state.order.orderOptions.doer,
            doers: state => state.order.doers,
            email: state => state.order.orderOptions.email,
            emails: state => staete.order.emails,
            userData: state => state.userData
        }),
        _selectedType: {
            get() { return this.selectedType },
            set(value) { this.selectType(value) }
        },
        _doer: {
            get() { return this.doer },
            set(value) { this.updateDoer(value) }
        },
        _email: {
            get() { return this.email },
            set(value) { this.updateEmail(value) }
        },
        validDoer() {
            if (!this._doer ) return
            if (this._doer.length > 4 && !this._doer.includes('null')) {
                return true
            } else return false
        },
        validEmail() {
            if (!this._email) return
            let mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
            if (this._email.match(mailformat)) {
                return true
            } else return false
        },
    },
    created() {
        switch(this._selectedType) {
            case 1: this.doerLabel = 'ФИО <b><em>адресата</em></b>:'; break;
            case 2: this.doerLabel = 'ФИО <b><em>исполнителя</em></b>:'; break;
            case 3: this.doerLabel = 'ФИО <b><em>внесшего информацию</em></b>:'; break; 
            case 4: this.doerLabel = 'ФИО <b><em>внесшего информацию</em></b>:'; break; 
        }
    },
    watch: {
        _selectedType(_selectedType) {
            if (this.userData && _selectedType === 2) this.updateDoer(this.userData.vrach_fio)
            switch(_selectedType) {
                case 1: this.doerLabel = 'ФИО <b><em>адресата</em></b>:'; break;
                case 2: this.doerLabel = 'ФИО <b><em>исполнителя</em></b>:'; break;
                case 3: this.doerLabel = 'ФИО <b><em>внесшего информацию</em></b>:'; break; 
                case 4: this.doerLabel = 'ФИО <b><em>внесшего информацию</em></b>:'; break; 
            }
        }
    }
}
</script>

<style>
#order-form {
    margin-bottom: 2rem;
}
#order-form .form-group {
    position: relative;
}

#order-form .invalid-feedback {
    position: absolute;
    left: 10px;
}

.short-list {
    display: none;
    overflow-wrap: break-word;
}
.route-mail {
    max-width: 300px;
}

@media (max-width: 536px) {
    /* .doer-input {
        margin-top: 1rem;
    } */
    #routes-table {
        display: none;
    }
    .short-list {
        display: block;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/OrderStatus.vue